import { render, staticRenderFns } from "./tablascrap.vue?vue&type=template&id=871ede7a"
import script from "./tablascrap.vue?vue&type=script&lang=js"
export * from "./tablascrap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports